/**
 * Diet / badge tag chips shown on customer-facing menu items.
 * Same value-set used by the admin item editor: best_seller, halal, vegan, veggie, spicy.
 */

const STYLES = {
    best_seller: { icon: "★", label: "Best seller", className: "text-gold border-[var(--gold)] bg-[var(--gold)]/10" },
    halal:       { icon: "☪", label: "Halal",        className: "text-[#86efac] border-[#86efac]/40 bg-[#86efac]/5" },
    vegan:       { icon: "🌱", label: "Vegan",       className: "text-[#86efac] border-[#86efac]/40 bg-[#86efac]/5" },
    veggie:      { icon: "🥬", label: "Veggie",      className: "text-[#86efac] border-[#86efac]/40 bg-[#86efac]/5" },
    spicy:       { icon: "🌶", label: "Spicy",       className: "text-[#ffb88c] border-[#ffb88c]/40 bg-[#ffb88c]/5" },
};

const ORDER = ["best_seller", "halal", "vegan", "veggie", "spicy"];

export const TagChips = ({ tags = [], size = "sm" }) => {
    if (!tags?.length) return null;
    const sized = size === "xs" ? "text-[8px] px-1.5 py-0.5" : "text-[9px] px-2 py-1";
    const sorted = [...tags].sort((a, b) => (ORDER.indexOf(a) === -1 ? 99 : ORDER.indexOf(a)) - (ORDER.indexOf(b) === -1 ? 99 : ORDER.indexOf(b)));
    return (
        <div className="flex flex-wrap items-center gap-1.5">
            {sorted.map((t) => {
                const s = STYLES[t] || { icon: "•", label: t, className: "text-muted border-[var(--border)]" };
                return (
                    <span
                        key={t}
                        className={`font-mono uppercase tracking-[0.14em] border inline-flex items-center gap-1 ${sized} ${s.className}`}
                        data-testid={`tag-${t}`}
                    >
                        <span style={{ fontSize: "1.05em", letterSpacing: 0 }}>{s.icon}</span>
                        <span>{s.label}</span>
                    </span>
                );
            })}
        </div>
    );
};

export default TagChips;
